import '.b0{max-width:1280px;}.ssr-plugin'
import '.ak{margin:0 auto;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.db{gap:144px;}.ssr-plugin'
import '.bf{max-width:568px;}.ssr-plugin'
import '.b3{margin-bottom:16px;}.ssr-plugin'
import '.b9{margin-bottom:48px;}.ssr-plugin'
import '.cr{margin-bottom:24px;}.ssr-plugin'
import '.ca{text-align:left;}.ssr-plugin'
import { styled } from 'inlines'
import { Layout } from '../../components/Layout.js'
import { colors } from '../../utils/colors.js'
import { useTrack } from '../../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../../shared/analyticsEvents.js'
import { TABLET } from '../../utils/breakpoints.js'
import { useLanguage } from '../../hooks/useLanguage.js'
import { useDictionary } from '../../hooks/useDictionary.js'
import { useContentQuery } from '../../ctx.js'
import { persistent } from '../../constants/index.js'
import { LinkNote, LinkNotes } from './LinkNotes.js'
import { useEffect } from 'react'
import { useScrollToTop } from '../../hooks/useScrollToTop.js'
import { BROAD_CASTER_MAP } from './BroadCasterMap.js'
import { useVotingRegion } from '../../hooks/useVotingRegion.js'

export const Privacy = () => {
  const track = useTrack('privacy')

  const [lang] = useLanguage()
  const [votingRegion] = useVotingRegion()
  const { legalGroupTitle, privacyPolicy, moreInfoReachOut } = useDictionary()
  const { data = '' } = useContentQuery('privacy', null, persistent)

  useScrollToTop()

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  const link = BROAD_CASTER_MAP[votingRegion?.code]

  return (
    <Layout>
      <styled.div className="b0 ak o a am db"
        style={{
          [TABLET]: {
            flexDirection: 'column',
            gap: '72px',
          },
        }}
      >
        {/* column 1 */}
        <styled.div className="bf"
          style={{
            textAlign: lang.rtl ? 'right' : 'left',
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
        >
          <h3 className="b3">{legalGroupTitle}</h3>
          <h2 className="b9" style={{ color: colors.primary,}}>
            {privacyPolicy}
          </h2>
          <p className="cr">{moreInfoReachOut}</p>
          {votingRegion?.code === 'ROW' ? (
            <></>
          ) : votingRegion?.code === 'CH' ? (
            <div>
              <LinkNote
                title={BROAD_CASTER_MAP['CH_DE'].name}
                link={BROAD_CASTER_MAP['CH_DE'].url}
              />
              <LinkNote
                title={BROAD_CASTER_MAP['CH_FR'].name}
                link={BROAD_CASTER_MAP['CH_FR'].url}
              />
              <LinkNote
                title={BROAD_CASTER_MAP['CH_IT'].name}
                link={BROAD_CASTER_MAP['CH_IT'].url}
              />
            </div>
          ) : (
            <LinkNote title={link?.name} link={link.url} />
          )}
        </styled.div>
        {/* column 2 */}
        <styled.div className="ca bf"
          dir="ltr"
          style={{
            '& h1': {
              fontSize: 'clamp(40px, 2.8vw, 56px)',
              marginBottom: '12px',
            },
            '& h2': {
              fontSize: 'clamp(22px, 2vw, 32px)',
              // @ts-ignore
              textAlign: 'left !important',
            },
            '& p': {
              margin: '1em 0em',
              // @ts-ignore
              textAlign: 'left !important',
            },
            '& ul': {
              fontSize: '16px',
              marginBottom: '12px',
            },
            '& li': {
              marginBottom: '6px',
            },
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
          dangerouslySetInnerHTML={{
            __html: typeof data === 'string' ? data : '',
          }}
        ></styled.div>
      </styled.div>
    </Layout>
  )
}
